import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { dictionariesApi } from '../../api';
import { IDictionariesState } from '../../types/features/dictionaries';
import { TGetB2cSettingsResponse_1 } from '../../repositories/mortgage-broker-calculator/v1/get-b2c-settings';

export const dictionariesSliceInitialState: IDictionariesState = {
  data: {
    availableRegions: [],
    banks: [],
    features: [],
    lastUpdateTimestamp: 0,
    isShadowMode: false,
    sortTypes: [],
  },
};

export const dictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState: dictionariesSliceInitialState,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(
      dictionariesApi.endpoints.getDictionaries.matchFulfilled,
      (state, { payload }: PayloadAction<TGetB2cSettingsResponse_1>) => {
        state.data = payload;
      },
    );
  },
});
